// @flow

import * as React from "react";
import { withRouter, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NProgress from "nprogress";
import queryString from "query-string";
import { isEqual } from "lodash";

import { fetchPosts } from "../api";
import actions from "../actions/index.js";
import useAsyncState from "../hooks/useAsyncState";
import Loader from "../components/atoms/Loader";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import CustomMeta from "../components/atoms/CustomMeta.js";
import { EventList } from "../components/organisms/ManageClubsEventsBody";
import Pagination from "../components/molecules/Pagination";

type PropsType = {
    match: any,
};

const ManageClubs = (props: PropsType): React.Node => {
    const POSTS_PER_PAGE = 15;
    const PAGINATION_WIDTH = 2;
    const history = useHistory();
    const dispatch = useDispatch();
    const [state, localActions] = useAsyncState();

    const [events, setEvents] = React.useState([]);
    const [headers, setHeaders] = React.useState({});

    const [params, setParams] = React.useState({ page_num: 1 });

    const queryParamProps = queryString.parse(history.location.search);
    const activePage = Number(queryParamProps.page_num) || 1;
    const totalPages = parseInt(headers["x-wp-totalpages"]) || 1;

    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];

    // set query params in state on change of any params
    if (!isEqual(queryParamProps, params)) {
        setParams(queryParamProps);
    }

    const scrollToTop = () => {
        // if (containerRef.current) {
        //     scrollToEl(containerRef.current);
        // }

        window.scrollTo({
            top: 0,
            left: 0,
            // behavior: "smooth",
        });
    };

    // initial mount use effect
    React.useEffect((): any => {
        NProgress.start();
        localActions.request();

        fetchPosts({
            endpoint: "/wp-json/user/v1/my-managed-events",
            postType: "event",
            page: params.page_num,
            perPage: POSTS_PER_PAGE,
            queryParms: {
                hosted_by: "activateuts",
                orderby: "upcoming",
                check_in_events: 1,
            },
        })
            .then(
                ({ data, headers }: { data: Array<any>, headers: Object }) => {
                    setEvents(data);
                    setHeaders(headers);
                    localActions.success();
                }
            )
            .catch(error => {
                localActions.fail(error.message);
            })
            .finally(() => {
                NProgress.done();
                scrollToTop();
            });
    }, [params.page_num]); // eslint-disable-line

    return (
        <React.Fragment>
            <CustomMeta title="Manage your events" />

            <HeroProfilePage
                heading="Manage your events"
                breadcrumbs={breadcrumbs}
                customClass="manage-clubs"
            />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <div className="row manage-clubs__content">
                            <div className="col-xs-12">
                                <Loader active={state.loading}>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {events && events.length ? (
                                                <EventList
                                                    events={events}
                                                    type="upcoming"
                                                    id={props.id}
                                                    isLoading={state.loading}
                                                    managed={true}
                                                />
                                            ) : (
                                                "No managed events found..."
                                            )}
                                        </div>
                                    </div>

                                    {totalPages > 1 ? (
                                        <Pagination
                                            ellipsisWidth={PAGINATION_WIDTH}
                                            pages={totalPages}
                                            activePage={activePage}
                                        />
                                    ) : null}

                                    <br />
                                    <br />
                                    <br />
                                </Loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

ManageClubs.preload = ({ location, passed: { store } }: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubs);
